document.addEventListener('on:cart:add', (event) => {
  if (sessionStorage.getItem("sizeWarningShown") === "true") return;

  const cart = event.detail?.cart;

  if (cart && cart.items) {
    checkCartForMultipleSizes(cart);
  } else {
    fetch("/cart.js")
      .then(response => response.json())
      .then(cartData => {
        checkCartForMultipleSizes(cartData);
      });
  }
});

function checkCartForMultipleSizes(cart) {
  if (sessionStorage.getItem("sizeWarningShown") === "true") return;

  const productVariantsMap = {};

  cart.items.forEach(item => {
    const productId = item.product_id;
    const variantId = item.variant_id;

    if (!productVariantsMap[productId]) {
      productVariantsMap[productId] = new Set();
    }
    productVariantsMap[productId].add(variantId);
  });

  let hasMultipleSizes = false;
  for (const productId in productVariantsMap) {
    if (productVariantsMap[productId].size > 1) {
      hasMultipleSizes = true;
      break;
    }
  }

  if (hasMultipleSizes) {
    sessionStorage.setItem("sizeWarningShown", "true");
    showCartWarning();
  }
}

function showCartWarning() {
  const warningBox = document.getElementById("size-warning-box");
  if (warningBox) {
    warningBox.style.display = "block";
  }
}